/**
 * DisableCheckoutsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'

import getAllDataInParallel from '../../helpers/get-all-data-in-parallel';
import DisableCheckoutsContext from './disable-checkouts-context'
import {
  fetchDisableCheckouts
} from './disable-checkouts-api'

export default function DisableCheckoutsProvider({ children }) {
  function fetchDisableCheckoutsAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchDisableCheckouts({
        ...params,
        ...args,
      }),
      key: 'disableCheckouts',
    })
  }

  const contextValue = {
    fetchDisableCheckouts,
    fetchDisableCheckoutsAll,
  }
  return (
    <DisableCheckoutsContext.Provider value={contextValue}>
      {children}
    </DisableCheckoutsContext.Provider>
  )
}
